<template>
  <div>
    <plex-header></plex-header>
    <div class="container" v-if="typeList.length > 0">
      <div class="row content-box">
        <div class="col-md-2" id="pc-type-list">
          <ul>
            <li v-for="(type,index) in typeList" @click="updateFaqs(type.id)" :class="[{'active-type': currentType === type.id}]">{{ type.name }}</li>
          </ul>
          <div class="right-border"></div>
        </div>

        <div class="col-xs-12" id="phone-type-list">
          <div class="type-list-box">
            <ul>
              <li v-for="type in typeList" @click="updateFaqs(type.id)" :class="[{'active-type': currentType === type.id}]">{{ type.name }}</li>
            </ul>
            <div class="bottom-border"></div>
          </div>
        </div>

        <div class="col-md-10 col-sm-12 col-xs-12" id="faq-lists">
          <spinner :show="loading" class="spinner-component"></spinner>
          <template v-for="(faq, index) in faqList" v-if="!!faq.question && !!faq.answer">
            <a href="" :id="'faq' + faq.id"></a>
            <div v-show="!loading" class="question-box"><span class="main-index">Q:</span><div v-html="faq.question" class="question"></div></div>
            <div v-show="!loading" class="answer-box"><span class="main-index">A:</span><div v-html="faq.answer" class="answer"></div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <plex-footer></plex-footer>
  </div>
</template>

<script>
  import PlexHeader from '../../components/plexHeader/mainHeader/Index.vue'
  import PlexFooter from '../../components/footer/Footer.vue';
  import Spinner from '../../components/Spinner.vue'

  export default {
    name: 'faq-view',
    components: { PlexHeader, PlexFooter, Spinner },
    data: function () {
      return {
        typeList: [],
        faqList: [],
        loading: false
      }
    },
    computed: {
      mediaType() {
        return this.$store.state.mediaType
      },
      faqType() {
        return Number(this.$route.query.faqType)
      },
      specialHeader: state => state.header.specialHeader
    },
    created() {
      this.initFaq()
      this.$store.commit('isSpecialHeader', false)
    },
    methods: {
      initFaq() {
        this.loading = true
        this.$http.get('api/faq-types').then((response) => {
          if (response.data.code === 0) {
            this.loading = false
            this.typeList = response.body.data
            if (this.faqType) {
              this.currentType = this.faqType
            } else this.currentType = response.body.data[0].id
            this.updateFaqs(this.currentType)
          }
        })
      },
      updateFaqs(typeId) {
        this.loading = true
        this.currentType = typeId
        this.$http.get('api/faq-by-type/' + typeId).then((response) => {
          if (response.body.code === 0) {
            this.loading = false
            this.faqList = response.body.data
          }
        })
      }
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/variables";
  * {
    padding: 0;
    margin: 0;
  }

  .header-box .main-header-pc.transparent-theme{
    background-image: linear-gradient(135deg, #416CF8 0%, #EC55FF 100%);
  }

  .container {
    background: #fff;
    width: 100%;
    min-height: 100vh;
  }

  .content-box {
    background: #fff;
    margin-top: 1.4rem;
    padding-left: .8rem;
    text-align: left;
    color: #999999;
  }
  .spinner-component {
    margin-top: 1rem !important;
  }

  ul {
    font-size: .14rem;
    letter-spacing: 0;
    li {
      list-style: none;
      text-decoration: none;
      background: transparent;
      border: 0;
      outline: 0;
      cursor: pointer;
    }
  }

  #faq-lists {
    padding: .4rem;
  }

  .question-box {
    position: relative;
    color: #111;
    font-weight: 600;
    &:nth-of-type(n+2) {
      margin-top: .4rem;
    }
    .main-index {
      line-height: .2rem;
      position: absolute;
      top: 0;
      left: 0;
    }
    .question {
      line-height: .2rem;
      margin-left: .23rem;
      letter-spacing: .01rem;
    }
  }

  .answer-box {
    margin-top: .16rem;
    position: relative;
    color:#666;
    .main-index {
      line-height: .2rem;
      position: absolute;
      top: 0;
      left: 0;
    }
    .answer {
      line-height: .2rem;
      margin-left: .23rem;
      letter-spacing: .01rem;
      a {
        color: $base-green;
        cursor: pointer;
      }
    }
  }

  #phone-type-list, #pc-type-list {
    display: none;
  }

  @mixin phone-style() {
    .container {
      background: #fff;
    }
    .content-box {
      padding: 0;
      margin: 0 auto;
      max-width:100%;
      overflow: hidden;
    }
    table{
        width: 300px !important;
    }

    #phone-type-list {
      display: block;
      .type-list-box {
        overflow: hidden;
        position: relative;
      }
      ul {
        width: inherit;
        overflow-x: auto;
        display: block;
        white-space: nowrap;
        position: relative;
        z-index: 2;
        &::-webkit-scrollbar {
          display: none;
        }
        &::-webkit-scrollbar{
          width:0;
        }
        &::-webkit-scrollbar-track {
          background:rgba(0,0,0,0);
        }

        &::-webkit-scrollbar-thumb {
          background:rgba(0,0,0,0);
        }

        &::-webkit-scrollbar-thumb:hover {
          background:rgba(0,0,0,0);
        }
      }
      li {
        display: inline-block;
        line-height: .4rem;
        margin-left: .24rem;
        color: #666;
        &:last-child {
          margin-right: .24rem;
        }
      }
      .active-type {
        color: #111;
        font-weight: 600;
        background: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%) center bottom / .24rem 0.03rem no-repeat;
      }
      .bottom-border {
        display: none
      }
    }
  
    #faq-lists {
      padding: .24rem;
    }
  }

  @mixin pad-style() {
    @include phone-style();
    ul {
      margin: 0 .4rem;
    }
    #phone-type-list .bottom-border {
      width: calc(100% - .8rem);
      left: .4rem;
    }
  }

  @mixin pc-style() {
    #pc-type-list {
      display: block;
      height: 100%;
      padding: .4rem 0;
      ul {
        z-index: 1;
        position: relative;
      }
      li {
        color: #666;
        z-index: 2;
        font-size: 14px;
        line-height: .6rem;
        letter-spacing: 0;
      }
      .active-type {
        color:#111;
        background: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%) right center / 0.03rem .4rem no-repeat;
      }
      .right-border {
        position: absolute;
        width: 1px;
        height: inherit;
        top: 0;
        right: 0px;
        z-index: 0;
        background: #E0D7E3;
      }
    }
  }


  @media (max-width: 767px) {
    @include phone-style();
  }

  @media (min-width: 768px) and (max-width: 1228px) {
    @include pad-style();
  }

  @media (min-width: 1180px) {
    @include pc-style();
  }

</style>



// WEBPACK FOOTER //
// FAQ.vue?e0f198b0